import { ShowMoreButtonContainer, ShowMoreCommonButton } from './styles'
import { commonMessages } from 'app/i18n/messages'
import { FormattedMessage } from 'react-intl'

interface ShowMoreButtonProps {
  onClick: () => void
  disabled?: boolean
}

function ShowMoreButton({ onClick, disabled = false }: ShowMoreButtonProps) {
  return (
    <ShowMoreButtonContainer>
      <ShowMoreCommonButton
        type="button"
        variant="secondary"
        onClick={onClick}
        disabled={disabled}
      >
        <FormattedMessage {...commonMessages.showMore} />
      </ShowMoreCommonButton>
    </ShowMoreButtonContainer>
  )
}

export default ShowMoreButton
